

export const list = [];
export function studentImageList(imageList) {
  // list.push(imageList)
  // 检查数组中是否已存在具有相同 ID 的对象
  if(imageList!=''){
    const existingObj = list.find(obj => obj.id === imageList.id);
    // 如果找到了具有相同 ID 的对象，则将新 imageListt替换到该对象中
    if (existingObj) {
      const index = list.findIndex(obj => obj.id === imageList.id);
      //循环添加数据给imglist数组
      imageList.imgList.forEach(item=>{
        list[index].imgList.push(item);
      })
      //有重复数据，过滤掉重复的数据
      const uniqueArray = [...new Set(list[index].imgList)];
      //赋值给当前数组
      list[index].imgList = uniqueArray;
      
    } else { 
      // 如果没有找到具有相同 ID 的对象，则把新的对象并添加到数组中
      list.push(imageList);
    }
  }else{
    return list.length=0
  }
}


// WEBPACK FOOTER //
// ./src/utils/studentImageLsit.js